import { render, staticRenderFns } from "./PreRecord.vue?vue&type=template&id=e6d89aa6&"
import script from "./PreRecord.vue?vue&type=script&lang=js&"
export * from "./PreRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports